import {Route, Switch} from "react-router-dom";
import {Overview} from "../view/myOrders/Overview";
import {get} from "../js/api";
import {useEffect, useState} from "react";
import {UpdateOrder} from "../view/myOrders/UpdateOrder";
import {addDirtyListener} from "../js/main";

export const MyOrders = () => {

    const [orders, setOrders] = useState(null);
    const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());

    const init = () => {
        get("/orders?year=" + selectedYear).then(resp => {
            setOrders(resp);
        });
    };

    useEffect(() => {
        init();
        addDirtyListener(init);
    }, [selectedYear]); // eslint-disable-line react-hooks/exhaustive-deps


    return (
        <Switch>
            <Route exact path="/meine-bestellungen">
                <Overview orders={orders} selectedYear={selectedYear} setSelectedYear={setSelectedYear}/>
            </Route>
            <Route exact path="/meine-bestellungen/bearbeiten/:orderId">
                <UpdateOrder orders={orders}/>
            </Route>
        </Switch>
    );

};